export default "__VITE_ASSET__CigcP5rr__"